import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { motion } from 'framer-motion'

export const Container = styled.div`
  position: relative;
  border-radius: 80px;
  overflow: hidden;
  width: 160px;
  height: 160px;
  border: 3px solid ${themeGet('colors.primary.main')};

  > img {
    width: 100%;
    height: 100%;
    transform: scale(103%, 103%);
  }
`

export const Overlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.overlay.primary')};
  z-index: 100;
`
